import React from 'react';

import { flagStyles } from '../settings';

const SvgUZ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5544px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgUZ;
